// Centralized articles data for the project

const Articles = [
	{
		id: 'wingtree',
		title: 'WingTree Review | A New Challenger in the Switch Market',
		type: 'switch',
		description: 'A review of WingTree\'s first two switch series: The Yuying and The Yunie.',
		thumbnail: '/pictures/articles/wingtree/banner.JPG',
		date: '2025-09-15',
		status: 'updated',
		link: '/articles/wingtree',
		visible: true
	},
	{
		id: 'bd60',
		title: 'BD60',
		type: 'keyboard',
		description: 'A compact 60% keyboard with a lilac colorway.',
		thumbnail: '/pictures/gallery/gallery1.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/bd60',
		visible: false
	},
	{
		id: 'brutal65_v2',
		title: 'Brutal65 V2',
		type: 'keyboard',
		description: 'A premium 65% keyboard with a robust, industrial design.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/brutal65_v2',
		visible: false
	},
	{
		id: 'cycle8',
		title: 'Cycle8',
		type: 'keyboard',
		description: 'A 80% keyboard with a Zeal colorway.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/cycle8',
		visible: false
	},
		{
		id: 'dk1_tkl',
		title: 'DK1-TKL',
		type: 'keyboard',
		description: 'A premium TKL at a budget price.',
		thumbnail: '/pictures/articles/dk1_tkl/banner.JPG',
		date: '2025-09-6',
		status: 'updated',
		link: '/articles/dk1_tkl',
		visible: true
	},
	{
		id: 'isabell60',
		title: 'Isabell60',
		type: 'keyboard',
		description: 'A 60% keyboard in gray.',
		thumbnail: '/pictures/gallery/gallery3.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/isabell60',
		visible: false
	},
	{
		id: 'krush65',
		title: 'Krush65',
		type: 'keyboard',
		description: 'A 65% keyboard in PC material.',
		thumbnail: '/pictures/gallery/gallery4.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/krush65',
		visible: false
	},
	{
		id: 'mode_envoy',
		title: 'Mode Envoy',
		type: 'keyboard',
		description: 'A modern 65% keyboard from Mode.',
		thumbnail: '/pictures/articles/envoy/banner.JPG',
		date: '2025-07-19',
		status: 'updated',
		link: '/articles/mode_envoy',
		visible: true
	},
	{
		id: 'mode_encore',
		title: 'Mode Encore',
		type: 'keyboard',
		description: 'A 65% keyboard from Mode in white.',
		thumbnail: '/pictures/gallery/gallery6.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/mode_encore',
		visible: false
	},
	{
		id: 'neo65',
		title: 'Neo65',
		type: 'keyboard',
		description: 'A 65% keyboard in black.',
		thumbnail: '/pictures/gallery/gallery8.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/neo65',
		visible: false
	},
	{
		id: 'neo65_cu',
		title: 'Neo65 Cu',
		type: 'keyboard',
		description: 'A 65% keyboard in purple.',
		thumbnail: '/pictures/gallery/gallery10.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/neo65_cu',
		visible: false
	},
	{
		id: 'neo70',
		title: 'Neo70',
		type: 'keyboard',
		description: 'A 70% keyboard in navy.',
		thumbnail: '/pictures/gallery/gallery12.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/neo70',
		visible: false
	},
	{
		id: 'neo_ergo',
		title: 'Neo Ergo',
		type: 'keyboard',
		description: 'A modern ergonomic keyboard from Neo.',
		thumbnail: '/pictures/gallery/gallery13.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/neo_ergo',
		visible: false
	},
	{
		id: 'pavlov',
		title: 'Pavlov Quick Review',
		type: 'keyboard',
		description: 'An elegant budget 65% keyboard in white.',
		thumbnail: '/pictures/gallery/gallery14.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/pavlov',
		visible: true
	},
	{
		id: 'qk65',
		title: 'QK65',
		type: 'keyboard',
		description: 'A 65% keyboard from QwertyKeys in black.',
		thumbnail: '/pictures/gallery/gallery1.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/qk65',
		visible: false
	},
	{
		id: 'boba_u4t',
		title: 'Boba U4T',
		type: 'switch',
		description: 'A tactile switch by Gazzew, known for its thocky sound and smoothness.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/boba_u4t',
		visible: false
	},
	{
		id: 'cherry_mx2a_black',
		title: 'Cherry MX2A Black',
		type: 'switch',
		description: 'A classic linear switch from Cherry, now with improved smoothness.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/cherry_mx2a_black',
		visible: false
	},
	{
		id: 'cherry_nixie',
		title: 'Cherry Nixie',
		type: 'switch',
		description: 'A vintage linear switch with a cult following.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/cherry_nixie',
		visible: false
	},
	{
		id: 'doom_tactile',
		title: 'Doom Tactile',
		type: 'switch',
		description: 'A tactile switch by Keebfront with a unique feel.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/doom_tactile',
		visible: false
	},
	{
		id: 'gateron_milky_yellow',
		title: 'Gateron Milky Yellow',
		type: 'switch',
		description: 'A budget-friendly linear switch popular for its smoothness.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/gateron_milky_yellow',
		visible: false
	},
	{
		id: 'gateron_smoothie',
		title: 'Gateron Smoothie',
		type: 'switch',
		description: 'A full POM linear switch from Gateron.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/gateron_smoothie',
		visible: false
	},
	{
		id: 'huano_caramel_latte',
		title: 'Huano Caramel Latte',
		type: 'switch',
		description: 'A linear switch by Huano with a caramel colorway.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/huano_caramel_latte',
		visible: false
	},
	{
		id: 'hmx_cloud',
		title: 'HMX Cloud',
		type: 'switch',
		description: 'A linear switch by HMX with a soft, cloud-like feel.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/hmx_cloud',
		visible: false
	},
	{
		id: 'hmx_cheese',
		title: 'HMX Cheese',
		type: 'switch',
		description: 'A linear switch by HMX with a unique yellow stem.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/hmx_cheese',
		visible: false
	},
	{
		id: 'hmx_hyacinth_v2',
		title: 'HMX Hyacinth V2',
		type: 'switch',
		description: 'A linear switch by HMX, version 2.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/hmx_hyacinth_v2',
		visible: false
	},
	{
		id: 'hmx_macchiato',
		title: 'HMX Macchiato',
		type: 'switch',
		description: 'A linear switch by HMX with a coffee-inspired colorway.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/hmx_macchiato',
		visible: false
	},
	{
		id: 'hmx_sugar_rush',
		title: 'HMX Sugar Rush',
		type: 'switch',
		description: 'A linear switch by HMX with a sweet, smooth feel.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/hmx_sugar_rush',
		visible: false
	},
	{
		id: 'hmx_sunset_gleam',
		title: 'HMX Sunset Gleam',
		type: 'switch',
		description: 'A linear switch by HMX with a sunset-inspired colorway.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/hmx_sunset_gleam',
		visible: false
	},
	{
		id: 'hmx_xinhai',
		title: 'HMX Xinhai',
		type: 'switch',
		description: 'A linear switch by HMX with a blue stem.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/hmx_xinhai',
		visible: false
	},
	{
		id: 'hmx_yogurt',
		title: 'HMX Yogurt',
		type: 'switch',
		description: 'A linear switch by HMX with a creamy feel.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/hmx_yogurt',
		visible: false
	},
	{
		id: 'keygeek_purple_dawn',
		title: 'Keygeek Purple Dawn',
		type: 'switch',
		description: 'A linear switch by Keygeek with a purple colorway.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/keygeek_purple_dawn',
		visible: false
	},
	{
		id: 'keygeek_uni',
		title: 'Keygeek Uni',
		type: 'switch',
		description: 'A linear switch by Keygeek.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/keygeek_uni',
		visible: false
	},
	{
		id: 'keygeek_y1x',
		title: 'Keygeek Y1X',
		type: 'switch',
		description: 'A linear switch by Keygeek.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/keygeek_y1x',
		visible: false
	},
	{
		id: 'keygeek_y3',
		title: 'Keygeek Y3',
		type: 'switch',
		description: 'A linear switch by Keygeek.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/keygeek_y3',
		visible: false
	},
	{
		id: 'mz_z1',
		title: 'MZ Z1',
		type: 'switch',
		description: 'A linear switch by MZ.',
		thumbnail: '/pictures/gallery/gallery2.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/mz_z1',
		visible: false
	},
	{
		id: 'gmk_8008',
		title: 'GMK 8008',
		type: 'keycap',
		description: 'A popular GMK keycap set in a dark blue and pink colorway.',
		thumbnail: '/pictures/gallery/gallery3.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/gmk_8008',
		visible: false
	},
	{
		id: 'gmk_8008_bloo',
		title: 'GMK 8008 Bloo',
		type: 'keycap',
		description: 'A blue variant of the GMK 8008 set.',
		thumbnail: '/pictures/gallery/gallery3.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/gmk_8008_bloo',
		visible: false
	},
	{
		id: 'gmk_blossom',
		title: 'GMK Blossom',
		type: 'keycap',
		description: 'A cherry blossom-themed GMK set.',
		thumbnail: '/pictures/gallery/gallery3.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/gmk_blossom',
		visible: false
	},
	{
		id: 'gmk_botanical',
		title: 'GMK Botanical',
		type: 'keycap',
		description: 'A botanical-themed GMK set with green accents.',
		thumbnail: '/pictures/gallery/gallery3.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/gmk_botanical',
		visible: false
	},
	{
		id: 'gmk_darling',
		title: 'GMK Darling',
		type: 'keycap',
		description: 'A pink and purple GMK set inspired by anime.',
		thumbnail: '/pictures/gallery/gallery3.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/gmk_darling',
		visible: false
	},
	{
		id: 'gmk_digital_nightmares',
		title: 'GMK Digital Nightmares',
		type: 'keycap',
		description: 'A cyberpunk-themed GMK set.',
		thumbnail: '/pictures/gallery/gallery3.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/gmk_digital_nightmares',
		visible: false
	},
	{
		id: 'gmk_dracula_r2',
		title: 'GMK Dracula R2',
		type: 'keycap',
		description: 'A dark, vampiric GMK set.',
		thumbnail: '/pictures/gallery/gallery3.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/gmk_dracula_r2',
		visible: false
	},
	{
		id: 'gmk_fuji',
		title: 'GMK Fuji',
		type: 'keycap',
		description: 'A GMK set inspired by Mount Fuji.',
		thumbnail: '/pictures/gallery/gallery3.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/gmk_fuji',
		visible: false
	},
	{
		id: 'gmk_honor_dark',
		title: 'GMK Honor Dark',
		type: 'keycap',
		description: 'A dark-themed GMK set.',
		thumbnail: '/pictures/gallery/gallery3.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/gmk_honor_dark',
		visible: false
	},
	{
		id: 'gmk_mercury',
		title: 'GMK Mercury',
		type: 'keycap',
		description: 'A GMK set with a silvery colorway.',
		thumbnail: '/pictures/gallery/gallery3.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/gmk_mercury',
		visible: false
	},
	{
		id: 'gmk_metropolis',
		title: 'GMK Metropolis',
		type: 'keycap',
		description: 'A city-inspired GMK set.',
		thumbnail: '/pictures/gallery/gallery3.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/gmk_metropolis',
		visible: false
	},
	{
		id: 'gmk_modern_materials_stone',
		title: 'GMK Modern Materials Stone',
		type: 'keycap',
		description: 'A stone-colored GMK set.',
		thumbnail: '/pictures/gallery/gallery3.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/gmk_modern_materials_stone',
		visible: false
	},
	{
		id: 'gmk_slasher',
		title: 'GMK Slasher',
		type: 'keycap',
		description: 'A horror-themed GMK set.',
		thumbnail: '/pictures/gallery/gallery3.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/gmk_slasher',
		visible: false
	},
	{
		id: 'gmk_tuzi',
		title: 'GMK Tuzi',
		type: 'keycap',
		description: 'A rabbit-themed GMK set.',
		thumbnail: '/pictures/gallery/gallery3.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/gmk_tuzi',
		visible: false
	},
	{
		id: 'jtk_fishing',
		title: 'JTK Fishing',
		type: 'keycap',
		description: 'A fishing-themed JTK set.',
		thumbnail: '/pictures/gallery/gallery3.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/jtk_fishing',
		visible: false
	},
	{
		id: 'jtk_night_sakura',
		title: 'JTK Night Sakura',
		type: 'keycap',
		description: 'A cherry blossom-themed JTK set.',
		thumbnail: '/pictures/gallery/gallery3.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/jtk_night_sakura',
		visible: false
	},
	{
		id: 'kkb_skidata_neo',
		title: 'KKB Skidata Neo',
		type: 'keycap',
		description: 'A Skidata-inspired KKB set.',
		thumbnail: '/pictures/gallery/gallery3.JPG',
		date: '2025-06-21',
		status: 'updated',
		link: '/articles/kkb_skidata_neo',
		visible: false
	}
];

export default Articles;
